/* istanbul ignore file */
import 'react-app-polyfill/ie9'; // For IE 9 support
import 'react-app-polyfill/stable';
import './config/polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './config/serviceWorker';

// if (process.env.REACT_APP_USE_MSW_MOCK_API === 'yes') {
//   const { worker } = require('./__mocks__/browser');
//   worker.start();
// }

if (process.env.REACT_APP_TAG_NAME) {
  console.log(process.env.REACT_APP_TAG_NAME);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
